import React from 'react';
import LogoPic from "../../assets/images/logo.png";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowRight} from '@fortawesome/free-solid-svg-icons'
import GetLocation from "./GetLocation";

const Actionbar = (props) => {

    return (
        <React.Fragment>
            <header className="navbar navbar-expand navbar-dark  bd-navbar actionbar rtl fixed-top max-w-lg">
                {
                    props.noBack !== 1 &&
                    <div className="float-right back-btn mx-3" onClick={() => {props.gohome ? window.location.replace('/home') :  window.history.back()} }>
                        <FontAwesomeIcon icon={faArrowRight}/>
                    </div>
                }

                <div className="mx-auto">
                    <img src={LogoPic} alt="BarSepar" className="ml-2" width={30}/>
                    <span className="px-1">
                        {props.title}
                    </span>
                </div>

            </header>
            <GetLocation />
        </React.Fragment>

    );
};

export default Actionbar;
